import { composeStaticPaths, composeStaticProps } from '@phoenix/core/frontend/shared/domain/compose';
import { getStaticPathsTranslations, getStaticPropsTranslations } from '@phoenix/core/frontend/shared/domain/i18n/i18n.static-generation';
import {
  getStaticPropsAssets,
  getStaticPropsFooter,
  getStaticPropsHeader,
  getStaticPropsNavigation,
} from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation';
import { GetStaticPaths, GetStaticProps } from 'next';
import { CustomAppProps } from '../../../models/app.model';
import { DashboardOverview } from '@phoenix/team-m/dashboard/frontend/feature/overview/dashboard-overview';

export function Index() {
  return <DashboardOverview />;
}

export default Index;

export const getStaticPaths: GetStaticPaths = composeStaticPaths(getStaticPathsTranslations('myStihl'));

export const getStaticProps: GetStaticProps = composeStaticProps<CustomAppProps>(
  getStaticPropsNavigation('myStihl_navigation'),
  getStaticPropsFooter('myStihl_footer'),
  getStaticPropsHeader(),
  getStaticPropsTranslations(),
  getStaticPropsAssets(['imagesDashboard'])
);
